import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes, Outlet } from "react-router-dom";
import { lazyWithRetry } from "./utils/lazyWithRetry";
import ProtectedRoute from "./routes/ProtectedRoute";
import Index from "./components/layout/Index";
import ScrollToTop from "./components/common/ScrollToTop";
import Loader from "./components/partial/Loader";

const NotFound = lazyWithRetry(() => import("./components/pages/NotFound"));
const Homepage = lazyWithRetry(() => import("./components/pages/homepage/Homepage"));
const TransactionRewards = lazyWithRetry(() => import("./components/pages/homepage/TransactionRewards"));
const SignIn = lazyWithRetry(() => import("./components/pages/SignIn"));
const GiftCardPage = lazyWithRetry(() => import("./components/pages/Giftcardpage"));
const GiftCardDetailPage = lazyWithRetry(() => import("./components/pages/GiftCardDetailPage"));
const ProductPage = lazyWithRetry(() => import("./components/pages/Productpage"));
const ProductDetailPage = lazyWithRetry(() => import("./components/pages/ProductDetailPage"));
const OrderHistoryPage = lazyWithRetry(() => import("./components/pages/OrderHistoryPage"));
const LeaderboardPage = lazyWithRetry(() => import("./components/pages/homepage/Leaderboardpage"));
const MilestoneDetailPage = lazyWithRetry(() => import("./components/layout/Milestonedetailpage"));
const AllCampaigns = lazyWithRetry(() => import("./components/layout/Allcampaigns"));

const App = () => {
  const Layout = () => (
    <Index>
      <Outlet />
    </Index>
  );

  return (
    <>
      <ScrollToTop>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/home" element={<ProtectedRoute><Homepage /></ProtectedRoute>} />
              <Route path="/" element={<ProtectedRoute><Homepage /></ProtectedRoute>} />
              <Route path="/transaction-rewards" element={<ProtectedRoute><TransactionRewards /></ProtectedRoute>} />
              <Route path="/all-campaigns" element={<AllCampaigns />} />
              <Route path="/milestone-details" element={<MilestoneDetailPage />} />
              <Route path="/gift-card" element={<ProtectedRoute><GiftCardPage /></ProtectedRoute>} />
              <Route path="/gift-card/:code" element={<ProtectedRoute><GiftCardDetailPage /></ProtectedRoute>}/>
              <Route path="/product" element={<ProtectedRoute><ProductPage /></ProtectedRoute>}/>
              <Route path="/product/:code"element={<ProtectedRoute><ProductDetailPage /></ProtectedRoute> } />
              <Route path="/order-history"element={<ProtectedRoute><OrderHistoryPage /></ProtectedRoute>}/>
              <Route path="/leaderboard" element={<ProtectedRoute><LeaderboardPage /></ProtectedRoute>}/>
              {/* <Route path="/games/spin-wheel" element={<SpinWheelGame />} /> */}
              <Route path="*"element={<ProtectedRoute><NotFound /></ProtectedRoute>}/>
            </Route>
            <Route path="/auth/sso-login" element={<SignIn />} />
          </Routes>
        </Suspense>
      </ScrollToTop>
    </>
  );
};

const WrappedApp = () => (
  <Router>
    <App />
  </Router>
);

export default WrappedApp;
